import Vue from 'vue'
import Vuex from 'vuex'

import { Loading,  QSpinnerFacebook,  } from 'quasar'
import { Notify } from 'quasar'

var URL = 'https://server-egov.konaweselatankab.go.id/';
// var URL = 'http://10.91.178.2:5095/';
// var URL = 'http://localhost:5001/';
// var URL = 'https://server-dev.simpeg.konaweselatankab.go.id/';

import Routerku from         '../library/routerku'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    coordinat : {
      lat:-4.034694, 
      lng: 122.484263
    },
    btn : {
      add : false,
      edit : false,
      remove : false,
    },
    url : {


      ULR_SI_ASN : 'https://training-apimws.bkn.go.id:8243/api/1.0/pns/data-utama/',
      TOKEN_AUTH : 'bearer eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJqSEVjQWFPcVFWemFYNGlVeExPVFJYb3lCSWp1a0Z3UHlZOFhtcTZhNkFrIn0.eyJleHAiOjE2OTE0NDU2MDMsImlhdCI6MTY5MTQwOTYwMywianRpIjoiZjRiMjRhYmItMWZiNi00NmUxLWIzNGMtYWNjMTlmMzUzYjdjIiwiaXNzIjoiaHR0cHM6Ly9pYW0tc2lhc24uYmtuLmdvLmlkL2F1dGgvcmVhbG1zL3B1YmxpYy1zaWFzbiIsImF1ZCI6ImFjY291bnQiLCJzdWIiOiIwOGQxNWE3NS00YjdkLTQ4YTUtYmI0YS01NmQxNWZjZDRiNmEiLCJ0eXAiOiJCZWFyZXIiLCJhenAiOiJkZXZlbG9wZXIiLCJzZXNzaW9uX3N0YXRlIjoiOTU1MmU3ZjUtNjFhMy00Y2EzLTkyNDctMzgxNDU3Y2M1MDJkIiwiYWNyIjoiMSIsInJlYWxtX2FjY2VzcyI6eyJyb2xlcyI6WyJyb2xlOnNpYXNuLWluc3RhbnNpOnBlcmVtYWphYW46b3BlcmF0b3IiLCJyb2xlOnNpYXNuLWluc3RhbnNpOnBlcmVuY2FuYWFuOmluc3RhbnNpLXBlbWJpbmEtcHBrIiwicm9sZTpzaWFzbi1pbnN0YW5zaTpwZXJlbWFqYWFuOmFwcHJvdmFsIiwicm9sZTpzaWFzbi1pbnN0YW5zaTpwZXJlbmNhbmFhbjppbnN0YW5zaS1vcGVyYXRvci1zb3RrIiwicm9sZTptYW5hamVtZW4td3M6ZGV2ZWxvcGVyIiwib2ZmbGluZV9hY2Nlc3MiLCJ1bWFfYXV0aG9yaXphdGlvbiIsInJvbGU6c2lhc24taW5zdGFuc2k6cGVyZW5jYW5hYW46aW5zdGFuc2ktcGVuZXRhcGFuLXNvdGsiLCJyb2xlOnNpYXNuLWluc3RhbnNpOnBlcmVuY2FuYWFuOmluc3RhbnNpLW1vbml0b3ItcGVyZW5jYW5hYW4ta2VwZWdhd2FpYW4iLCJyb2xlOnNpYXNuLWluc3RhbnNpOnByb2ZpbGFzbjp2aWV3cHJvZmlsIl19LCJyZXNvdXJjZV9hY2Nlc3MiOnsiYWNjb3VudCI6eyJyb2xlcyI6WyJtYW5hZ2UtYWNjb3VudCIsIm1hbmFnZS1hY2NvdW50LWxpbmtzIiwidmlldy1wcm9maWxlIl19fSwic2NvcGUiOiJwcm9maWxlIGVtYWlsIiwiZW1haWxfdmVyaWZpZWQiOmZhbHNlLCJuYW1lIjoiSEFTQkFSIEpBWUEiLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiIxOTg1MDkyNzIwMTAwMTEwMDciLCJnaXZlbl9uYW1lIjoiSEFTQkFSIiwiZmFtaWx5X25hbWUiOiJKQVlBIiwiZW1haWwiOiJoYXNiYXJhbWJhaXB1YUBnbWFpbC5jb20ifQ.gcwVjnk05VE72WLrP5WtBZMlvQRVcr1imhcloUoIdusCEoKpsL90NvU5z3F4YhYg28f7eumgEnItkdWp0ENbETwioN1qU2Xn_n13GmIxD_HT2ZTMs4xnCevbZIiZjcI3iHu8G3v86oknjcrfgHdHMkPHJrz4wm0PR_ayhRHL3lrIwUNUsdVxV_MQAirPbVeE-kVQvLzI3lI8g_H1FY2iUuysGf8bEuqdBswptuH8hrn1JUb_XDeX0Yl67pD7gFSWnez32g3cMa_8AaXPLRkyDJw9GAoJhTK5wQkAD25tTKJQXud4YyNnEH5P6wIejir5MzIL0D7mHc80-wYGbLNjxA',
      TOKEN_AUTHORIZATION : 'Bearer eyJ4NXQiOiJNell4TW1Ga09HWXdNV0kwWldObU5EY3hOR1l3WW1NNFpUQTNNV0kyTkRBelpHUXpOR00wWkdSbE5qSmtPREZrWkRSaU9URmtNV0ZoTXpVMlpHVmxOZyIsImtpZCI6Ik16WXhNbUZrT0dZd01XSTBaV05tTkRjeE5HWXdZbU00WlRBM01XSTJOREF6WkdRek5HTTBaR1JsTmpKa09ERmtaRFJpT1RGa01XRmhNelUyWkdWbE5nX1JTMjU2IiwiYWxnIjoiUlMyNTYifQ.eyJzdWIiOiIxOTg1MDkyNzIwMTAwMTEwMDciLCJhdXQiOiJBUFBMSUNBVElPTiIsImF1ZCI6IkZkd0h5VmkyOXZKbHM3dGoyTG00S2h1eDRQTWEiLCJuYmYiOjE2OTE0MDkyNTMsImF6cCI6IkZkd0h5VmkyOXZKbHM3dGoyTG00S2h1eDRQTWEiLCJzY29wZSI6ImRlZmF1bHQiLCJpc3MiOiJodHRwczpcL1wvbG9jYWxob3N0Ojk0NDNcL29hdXRoMlwvdG9rZW4iLCJleHAiOjE2OTE0MTI4NTMsImlhdCI6MTY5MTQwOTI1MywianRpIjoiZWM3Y2IwM2UtNGQ2ZC00YjIzLWFmNTYtMjY0NDFhZjhjODQ3In0.kFPtrX0wKiRZ6a08AhNG38Owgo5JKYy20FBY8ftf1rfm4prnzZLGY9OhLga9CKOFa200duWc0OqKh2f0mbGG0dIOmA5f7CnEpIx7VbRibZJsswCEfH0yhiAdax5EkBKXTkPBiO_649X-4ebhnFseEYUiDk2NYYESY30QWX2ZUmrMJ_5uVwM6ZyeRp2L9LwZMkOMNR1z11of8IpsCTf7JdX3Rr0ARVKoTbsZhTWnjnMnpYimFBHB6oZX0M425ERbCwPc0aNiZD_QLkTT78V8wd2j-ODeX7-ekhJJlxpe5_FmEjU05g-4Wi40jiSvc-6cU6e7RUUau5jOFUtcq48n-wQ',
      URL_APP: URL,
      URL_DM_MENU : URL + 'api/v1/simpeg_menuList/',
      URL_DM_KLP_USERS : URL + 'api/v1/simpeg_kelompokUsers/',
      URL_DM_REGISTER : URL + 'api/v1/simpeg_registrasi/',

      checkAuth : URL + 'api/v1/checkAuth/',

      URL_simpeg_home : URL + 'api/v1/simpeg_home/',

      URL_planning_provinsi : URL + 'api/v1/planning_provinsi/',
      URL_planning_kabupaten : URL + 'api/v1/planning_kabupaten/',
      URL_planning_kecamatan : URL + 'api/v1/planning_kecamatan/',
      URL_simpeg_instansi : URL + 'api/v1/simpeg_instansi/',
      URL_simpeg_unit_kerja : URL + 'api/v1/simpeg_unit_kerja/',

      URL_simpeg_jenis_jabatan : URL + 'api/v1/simpeg_jenisJabatan/',
      URL_simpeg_kelas_jabatan : URL + 'api/v1/simpeg_kelasJabatan/',
      URL_simpeg_jabatan : URL + 'api/v1/simpeg_jabatan/',
      
      URL_simpeg_biodata : URL + 'api/v1/simpeg_biodata/',
      URL_simpeg_esselon : URL + 'api/v1/simpeg_esselon/',
      URL_simpeg_golongan : URL + 'api/v1/simpeg_golongan/',
      URL_simpeg_simpeg_jenisKelamin : URL + 'api/v1/simpeg_jenisKelamin/',
      URL_simpeg_simpeg_statusKeluarga : URL + 'api/v1/simpeg_statusKeluarga/',
      URL_simpeg_agama : URL + 'api/v1/simpeg_agama/',
      URL_simpeg_strata_ijazah : URL + 'api/v1/simpeg_strata_ijazah/',

      URL_simpeg_monitoring_pejabat : URL + 'api/v1/simpeg_monitoring_pejabat/',

      URL_simpeg_karpeg : URL + 'api/v1/simpeg_karpeg/',
      URL_simpeg_skp : URL + 'api/v1/simpeg_skp/',
      URL_simpeg_riwayat_pengangkatan : URL + 'api/v1/simpeg_riwayat_pengangkatan/',
      URLsimpeg_riwayat_kepangkatan : URL + 'api/v1/simpeg_riwayat_kepangkatan/',
      URL_simpeg_pendidikan_formal : URL + 'api/v1/simpeg_pendidikan_formal/',
      URL_simpeg_pendidikan_non_formal : URL + 'api/v1/simpeg_pendidikan_non_formal/',
      URL_simpeg_riwayat_jabatan_struktural : URL + 'api/v1/simpeg_riwayat_jabatan_struktural/',
      URL_simpeg_riwayat_jabatan_fungsional : URL + 'api/v1/simpeg_riwayat_jabatan_fungsional/',
      URL_simpeg_diklat_fungsional : URL + 'api/v1/simpeg_diklat_fungsional/',
      URL_simpeg_diklat_struktural : URL + 'api/v1/simpeg_diklat_struktural/',
      URL_simpeg_riwayat_kursus : URL + 'api/v1/simpeg_riwayat_kursus/',
      URL_simpeg_tupoksi : URL + 'api/v1/simpeg_tupoksi/',
      URL_simpeg_anak : URL + 'api/v1/simpeg_anak/',
      URL_simpeg_suami_istri : URL + 'api/v1/simpeg_suami_istri/',
      URL_simpeg_riwayat_penghargaan : URL + 'api/v1/simpeg_riwayat_penghargaan/',

      URL_simpeg_angka_kredit : URL + 'api/v1/simpeg_angka_kredit/',
      URL_simpeg_riwayat_hukdis : URL + 'api/v1/simpeg_hukdis/',
      URL_simpeg_cpns : URL + 'api/v1/simpeg_cpns/',
    },

    list_menu : null,
    aksesMenu : {},

    listKabKota: [],
    listKec: [],
    listDesKel: [],

    list_biodata: [],
    list_instansi: [],
    list_unit_kerja: [],
    list_jenis_jabatan: [],
    list_kelas_jabatan: [],
    list_jabatan: [],
    list_jenis_kelamin: [],
    list_status_keluarga: [],
    list_agama: [],
    list_strata_ijazah : [],
    list_jns_kompetensi : [],
    list_jns_diklat : [],
    list_jns_latihan_struktural : [],
    list_metode_absen : [],
    list_refJabatan_siasn : [],
    list_jns_hukuman : [],
    list_alasan_hukuman : [],
    list_jns_kedudukan_hukum : [],
    list_jenis_pegawai :[
      {id :1, uraian : 'PNS'},
      {id :2, uraian : 'PPPK'},
      {id :3, uraian : 'Honorer'},
    ],

    list_klp : [],


    agamaSelect : [
      {id : '1', nama : 'Islam'},
      {id : '2',nama : 'Katolik'},
      {id : '3',nama : 'Protestan'},
      {id : '4',nama : 'Hindu'},
      {id : '5',nama : 'Buddha'},
      {id : '6',nama : 'Kong Hu Cu'},
    ],

    golonganSelect : [],
    agamaSelect : [],
    jenisKelSelect : [],
    statusKelSelect : [],
    pendidikanAkhirSelect : [],

    esselonSelect: [],

    kepemilikanTaspenSelect : [
      {id : '1',nama : 'Ada'},
      {id : '2',nama : 'Tidak Ada'},
    ],

    levelJabatanSelect : [
      {id : 1, _nama : 'I'},
      {id : 2 ,_nama : 'II'},
      {id : 3, _nama : 'III'},
      {id : 4, _nama : 'IV'},
      {id : 5, _nama : 'V'},
      {id : 6, _nama : 'VI'},
      {id : 7, _nama : 'VII'},
      {id : 8, _nama : 'VIII'},
    ],



    list_instansi_siasn: [],
    list_satker_siasn: [],
    list_unor_siasn: [],
    list_jabatan_fungsional_siasn: [],
    list_jabatan_fungsional_umum_siasn: [],














    unit_kerja : '',

    page_first: 1,
    page_last: 0,
    cari_value: "",
    cek_load_data : true,

    type : [
      {id : 0, uraian : 'Single Menu'},
      {id : 1, uraian : 'Multy Menu'}
    ],
    menu : Routerku.menu
    
  },
  mutations: {

    getStorage(state){
      var get_profile = JSON.parse(localStorage.profile);
      state.unit_kerja = get_profile.profile.unit_kerja; 
    },
    shoWLoading(){
      const spinner = typeof QSpinnerFacebook !== 'undefined'
        ? QSpinnerFacebook // Non-UMD, imported above
        : Quasar.components.QSpinnerFacebook // eslint-disable-line


      Loading.show({
        spinner,
        spinnerColor: 'yellow',
        spinnerSize: 140,
        backgroundColor: 'purple',
        // message: 'Loading... Tunggu beberapa saat, system sedang menyesuaikan akun anda..!',
        // messageColor: 'white'
      })
    },
    hideLoading(){
      Loading.hide()
    },
    shoWNotify(state, message, color, icon){
      Notify.create({
        message: message,
        color: color,
        position : 'top-right',
        icon:icon
      })
    },
  },
  actions: {
  },
  modules: {
  }
})
